import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

interface WrapperProps {
  $imageOverlay: boolean;
  $iconOnly: boolean;
}

export const Wrapper = styled.button<WrapperProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $iconOnly }) =>
    $iconOnly
      ? `${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'}`
      : `${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'} ${baseVariables.spacers?.spacers?.[3] ?? '1rem'}`};
  background-color: ${({ $imageOverlay }) =>
    $imageOverlay ? 'var(--t-color-control-background-overlay, rgba(28, 28, 28, 0.52))' : 'transparent'};
  backdrop-filter: ${({ $imageOverlay }) => ($imageOverlay ? 'blur(2px)' : 'none')};
  -webkit-backdrop-filter: ${({ $imageOverlay }) => ($imageOverlay ? 'blur(2px)' : 'none')};
  border: ${({ $iconOnly, $imageOverlay }) =>
    $iconOnly && !$imageOverlay
      ? `1px solid var(--t-color-control-foreground-reverse, ${baseVariables.color.base20})`
      : 'none'};
  border-radius: ${({ $iconOnly }) => ($iconOnly ? '50%' : 'var(--t-buttons-border-radius, 2rem)')};
  color: var(--t-brand-fg-color, ${baseVariables.color.base20});
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:disabled {
    opacity: var(--t-button-disabled-opacity, 0.5);
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    transform: scale(1.02);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: var(--t-overlay-background, rgba(0, 0, 0, 0.54));
  pointer-events: none;
  z-index: 1;
`;

export const Content = styled.div<{ $imageOverlay: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${baseVariables.spacers?.spacers?.[2] ?? '0.5rem'};
  z-index: 2;
  color: ${({ $imageOverlay }) =>
    $imageOverlay ? `var(--t-button-content-color, ${baseVariables.color.base20})` : 'inherit'};

  .icon::before {
    color: ${({ $imageOverlay }) =>
      $imageOverlay ? `var(--t-button-icon-color, ${baseVariables.color.base20})` : 'inherit'};
  }
`;

export const Text = styled.span`
  font: normal normal 700 var(--t-font-m-font-size-viewport-xs, 1rem) /
    var(--t-font-m-line-height-viewport-xs, 1.375rem) var(--t-base-font-family);
  color: var(--t-button-secondary-hover-fg-color, ${baseVariables.color.base20});
  white-space: nowrap;
`;
